const t={desktop:4,tablet:2.5,mobile:1.5};export{t as PER_ROW};
//# sourceMappingURL=constants.js.map
